/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import centroid from "@turf/centroid";
import { timeout } from "workbox-core/_private";

/*COMPONENT*/
import PARENT_HBU_MANUAL from "./PARENT_HBU_MANUAL";

/*REDUX*/
import {
  get_ai_hbu_summary,
  get_ai_sheet_chat_list,
  get_ai_sini_sheet,
} from "../../App/actions/ai_excel";
import { push_ai_sheet_chat } from "../../App/actions/push_ai_sheet_chat";
import { generate_ai_hbu_summary } from "../../App/actions/generate_ai_hbu_summary";

/*PICTURE*/

/*FUNCTION*/
import uuid from "../../App/validation/uuid";
import {
  get_value_cell,
  numberToColumn,
} from "../../App/validation/calculateExcelFormula";

/*DATA*/

/*CONST*/

const EXCEL_HBU = ({
  geo_layer_id,
  feature_key,
  field_key,
  layer,
  sini,
  worksheet,
  get_ai_hbu_summary,
  get_ai_sheet_chat_list,
  get_ai_sini_sheet,
  push_ai_sheet_chat,
  generate_ai_hbu_summary,
  ...restProps
}) => {
  // eslint-disable-next-line no-unused-vars
  const [user_message, set_user_message] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [user_message_hbu, set_user_message_hbu] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [mode_capex, set_mode_capex] = useState("manual");
  // eslint-disable-next-line no-unused-vars
  const [is_chat_ai_show, set_is_chat_ai_show] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modal_re_hbu, set_modal_re_hbu] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [is_loading, set_is_loading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [is_timeout, set_is_timeout] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modal_show_pedoman, set_modal_show_pedoman] = useState(false);

  useEffect(() => {
    //basic
    const params = {
      geo_layer_id,
      feature_key,
      field_key,
    };
    get_ai_hbu_summary(params);
    get_ai_sheet_chat_list(params);

    //advance
    const feature_object_selected = layer?.feature_object_selected;
    const type = feature_object_selected?.geometry?.type;

    let long = 0;
    let lat = 0;

    if (type === "Point") {
      long = feature_object_selected?.geometry?.coordinates?.[0];
      lat = feature_object_selected?.geometry?.coordinates?.[1];
    } else if (feature_object_selected) {
      const geojson = {
        type: "FeatureCollection",
        features: [feature_object_selected],
      };
      const feature_center = centroid(geojson);
      long = feature_center?.geometry?.coordinates?.[0];
      lat = feature_center?.geometry?.coordinates?.[1];
    }

    const params_sini = {
      geo_layer_id,
      feature_key,
      field_key,
      long,
      lat,
      request_id: uuid(),
      is_from_excel: true,
      sini_data_mode: "sini_general",
      show_survey_1: true,
    };
    get_ai_sini_sheet(params_sini, "ai_hbu");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-unused-vars
  const toggle_show_pedoman = () => {
    set_modal_show_pedoman((prev) => !prev);
  };

  // eslint-disable-next-line no-unused-vars
  const on_set_mode_capex = (mode_capex_val) => {
    set_mode_capex(mode_capex_val);
  };

  // eslint-disable-next-line no-unused-vars
  const toggle_re_hbu = () => {
    set_modal_re_hbu((prev) => !prev);
  };

  // eslint-disable-next-line no-unused-vars
  const on_change = (event) => {
    const { name, value } = event.target;
    if (name === "user_message") {
      set_user_message(value);
    } else if (name === "user_message_hbu") {
      set_user_message_hbu(value);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handle_refresh = async () => {
    //basic
    const params = {
      geo_layer_id,
      feature_key,
      field_key,
    };
    set_is_loading(true);
    await get_ai_hbu_summary(params);
    set_is_loading(false);
  };

  const convert2DArrayToObjects = (arr) => {
    return arr.map((row) => {
      return row.reduce((obj, value, index) => {
        if (value !== null && value !== "") {
          obj[numberToColumn(index)] = value;
        }
        return obj;
      }, {});
    });
  };

  // eslint-disable-next-line no-unused-vars
  const on_generate_ai_hbu_summary = async () => {
    set_is_loading(true);

    const { ai_parent_detail_list, sheet_object_selected } = sini;
    const sini_object = ai_parent_detail_list?.find(
      (item) => item.request_id === sheet_object_selected.request_id,
    );

    const sini_not_used_list = ["people_spending"];

    for await (const key of sini_not_used_list) {
      if (sini_object?.[key]) delete sini_object[key];
    }

    let current_worksheet = JSON.parse(JSON.stringify(worksheet));
    if (current_worksheet["Read Me"]) delete current_worksheet["Read Me"];
    if (current_worksheet["DATA"]) delete current_worksheet["DATA"];
    if (current_worksheet["Asumsi Finansial"])
      delete current_worksheet["Asumsi Finansial"];

    const sheet_array = Object.keys(current_worksheet).map((item) => {
      let sheet = current_worksheet[item];
      sheet[0][0] = item;
      return convert2DArrayToObjects(sheet);
    });

    const landvalue_one = sini_object?.landvalue_one;
    const landvalue_value = landvalue_one?.properties?.["HARGA"];

    const luas_tanah = get_value_cell("D12", current_worksheet, "Data Objek");
    const capex_tanah = luas_tanah * landvalue_value;

    const body = {
      worksheet: sheet_array,
      geo_layer_id,
      feature_key,
      field_key,
      sini_object,
      user_message_hbu,
      capex_tanah,
    };

    const is_timeout_res = (await generate_ai_hbu_summary(body)) === "Timeout";
    if (is_timeout_res) await timeout(25000);

    set_user_message_hbu("");
    set_modal_re_hbu(false);
    set_is_loading(false);
    set_is_timeout(is_timeout_res ? true : false);
  };

  // eslint-disable-next-line no-unused-vars
  const reset_ai_hbu_summary = () => {
    const { ai_parent_detail_list, sheet_object_selected } = sini;
    const sini_object = ai_parent_detail_list.find(
      (item) => item.request_id === sheet_object_selected.request_id,
    );

    const sheet_array = Object.keys(worksheet).map((item) => {
      let sheet = worksheet[item];
      sheet[0][0] = item;
      return convert2DArrayToObjects(sheet);
    });

    const body = {
      worksheet: sheet_array,
      geo_layer_id,
      feature_key,
      field_key,
      sini_object,
      user_message_hbu: "",
    };
    generate_ai_hbu_summary(body);

    set_user_message_hbu("");
    set_modal_re_hbu(false);
  };

  // eslint-disable-next-line no-unused-vars
  const on_push_ai_sheet_chat = () => {
    const {
      ai_parent_detail_list,
      sheet_object_selected,
      ai_hbu_summary_object,
    } = sini;
    const sini_object = ai_parent_detail_list.find(
      (item) => item.request_id === sheet_object_selected.request_id,
    );
    const body = {
      ai_hbu_summary_object,
      user_message,
      geo_layer_id,
      feature_key,
      field_key,
      sini_object,
    };
    push_ai_sheet_chat(body);
    set_user_message("");
  };

  // eslint-disable-next-line no-unused-vars
  const toggle_chat_ai = () => {
    set_is_chat_ai_show((prev) => !prev);
  };

  const componentProps = {
    geo_layer_id,
    feature_key,
    field_key,
    layer,
    sini,
    worksheet,
    get_ai_hbu_summary,
    get_ai_sheet_chat_list,
    get_ai_sini_sheet,
    push_ai_sheet_chat,
    generate_ai_hbu_summary,
    ...restProps,
  };

  return (
    <main>
      <PARENT_HBU_MANUAL {...componentProps} />
    </main>
  );
};

const mapStateToProps = (state) => ({
  sini: state.sini,
  layer: state.layer,
});

export default connect(mapStateToProps, {
  generate_ai_hbu_summary,
  get_ai_hbu_summary,
  push_ai_sheet_chat,
  get_ai_sheet_chat_list,
  get_ai_sini_sheet,
})(EXCEL_HBU);
